import React from 'react'

import { PageLayout } from '../..'

class CustomerPage extends React.Component {
  render() {
    return (
      <PageLayout>
      </PageLayout>
    )
  }
}

export default CustomerPage
